<template>
  <div class="nd-page">
    <header class="nd-page-header">
      <div>
        <h1 id="title" class="page-title">Tipos de Exame</h1>
        <p class="nd-page-kicker">Classificações usadas no fluxo de exames e solicitações laboratoriais.</p>
      </div>
      <v-btn id="btnNew" type="button" color="primary" elevation="0" to="/tipos-de-exame/novo">
        <v-icon left small>mdi-plus</v-icon>
        Incluir
      </v-btn>
    </header>

    <module-stat-grid module="examTypes" :items="dataList.data" :count="dataList.count" />

    <v-card class="nd-section-card">
      <div class="nd-table-toolbar">
        <div>
          <div class="nd-table-toolbar__title">Tipos de exame</div>
          <div class="nd-table-toolbar__subtitle">Filtre, revise e atualize classificações de exames.</div>
        </div>
        <v-form class="nd-table-toolbar__actions" @submit.prevent="load()">
          <v-text-field
            class="nd-search-field"
            dense
            placeholder="Buscar tipo de exame"
            v-model="dataList.filter.search" hide-details="auto"
            outlined
            prepend-inner-icon="mdi-magnify"
          ></v-text-field>
          <v-btn id="btnFilter" type="submit" outlined color="primary" elevation="0">
            <v-icon left size="18">mdi-filter-outline</v-icon>
            Filtrar
          </v-btn>
        </v-form>
      </div>
            <v-data-table
              :headers="dataList.headers"
              :items="dataList.data"
              @update:items-per-page="pageSizeChanged"
              @update:page="pageChanged"
              :server-items-length="dataList.count"
              :disable-sort="true"
              :loading="dataList.loading"
              no-data-text="Nenhum tipo de exame encontrado"
              loading-text="Carregando dados..."
              class="app-table hover-table"
              :options.sync="dataList.options"
              :footer-props="dataList.footerOptions"
            >
              <template v-slot:[`item.name`]="{ item }">
                <div class="nd-entity-cell">
                  <span class="nd-entity-mark">{{ item.name ? item.name.charAt(0) : "E" }}</span>
                  <div>
                    <strong>{{ item.name }}</strong>
                    <small>ID {{ item.id }}</small>
                  </div>
                </div>
              </template>

              <template v-slot:[`item.date`]="{ item }">
                {{ item.date ? new Date(item.date).toLocaleString('pt-BR') : '-' }}
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <div class="row-actions">
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-btn icon small v-on="on" @click="viewItem(item)">
                        <v-icon size="19">mdi-pencil-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Editar tipo de exame</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-btn icon small v-on="on" @click="deleteItem(item)">
                        <v-icon size="19">mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Remover tipo de exame</span>
                  </v-tooltip>
                </div>
              </template>
            </v-data-table>
    </v-card>
  </div>
</template>

<script>
import ModuleStatGrid from "@/components/ModuleStatGrid.vue";
import axios from "axios";

export default {
  components: { ModuleStatGrid },
  name: "ExamTypesList",

  data: () => ({
    dataList: {
      filter: { search: "" },
      headers: [
        { text: "Nome", value: "name" },
        { text: "Data", value: "date" },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
      data: [],
      loading: false,
      count: 0,
      options: { page: 1, itemsPerPage: 10 },
      footerOptions: {
        itemsPerPageText: "Itens por página:",
        itemsPerPageOptions: [10, 20, 30, 40, 50],
        pageText: "{0}-{1} de {2}",
      },
    },
  }),

  created() {
    this.load();
  },

  computed: {
    lastRecordDate() {
      const latest = this.dataList.data.find((item) => item.date);
      return latest ? new Date(latest.date).toLocaleDateString("pt-BR") : "-";
    },
  },

  methods: {
    pageChanged(page) {
      this.dataList.options.page = page;
      this.load();
    },

    pageSizeChanged(size) {
      this.dataList.options.itemsPerPage = size;
      this.load();
    },

    async load() {
      this.dataList.loading = true;
      try {
        const params = {
          start: (this.dataList.options.page - 1) * this.dataList.options.itemsPerPage,
          limit: this.dataList.options.itemsPerPage,
        };
        if (this.dataList.filter.search) params.search = this.dataList.filter.search;

        const result = await axios.get("/exam-types", { params });
        this.dataList.data = result.data.data;
        this.dataList.count = result.data.count;
      } catch (error) {
        this.$dialog.notify.error("Erro ao carregar tipos de exame.", { position: "top-right", timeout: 5000 });
      } finally {
        this.dataList.loading = false;
      }
    },

    viewItem(item) {
      this.$router.push(`/tipos-de-exame/${item.id}`);
    },

    async deleteItem(item) {
      const proceed = await this.$dialog.confirm({
        text: `Deseja realmente remover o tipo de exame "${item.name}"?`,
        title: "Confirmar Exclusão",
        actions: { false: "Cancelar", true: { text: "Remover", color: "error" } },
      });

      if (proceed) {
        this.dataList.loading = true;
        try {
          await axios.delete(`/exam-types/${item.id}`);
          this.$dialog.notify.info(`Tipo de exame "${item.name}" removido com sucesso!`, { position: "top-right", timeout: 2000 });
          this.load();
        } catch (error) {
          this.$dialog.notify.error("Erro ao remover tipo de exame.", { position: "top-right", timeout: 5000 });
        } finally {
          this.dataList.loading = false;
        }
      }
    },
  },
};
</script>
